// regEx for checking email format
export const checkEmailFormat = (email) => {
  let regExForEmail = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
  return regExForEmail.test(email) ? true : false;
};
